<template>
  <div class="admin-pagination-container">
    <v-pagination
      v-if="totalPages > 1"
      v-model="value"
      :length="totalPages"
      :total-visible="6"
    ></v-pagination>
    <div class="total" v-if="showTotal">Totalt antal: {{ totalRecords }}</div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    pageNumber: { type: Number },
    totalPages: { type: Number },
    totalRecords: { type: Number },
    showTotal: { type: Boolean, default: false },
  },
  computed: {
    value: {
      get() {
        return this.pageNumber
      },
      set(val) {
        this.$emit('change', val)
      },
    },
  },
}
</script>

<style lang="less" scoped>
.admin-pagination-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .total {
    margin-right: 9px;
    font-size: 12px;
    color: #999;
  }

}
</style>
